import React, { useState } from 'react';
import { Table, Button, Tag } from 'antd';
import { DownOutlined, UpOutlined } from '@ant-design/icons';

function TopProductsTable({ data, columns, title, showTopCount }) {
  const [expanded, setExpanded] = useState(false);

  const displayedData = expanded ? data : data?.slice(0, showTopCount || 5);

  return (
    <div className="bg-white rounded-xl  overflow-hidden">
      <div className="px-2 pt-3 pb-2 text-center">
        <h2 className="text-2xl font-bold mb-1">{title || 'Our Top Products'}</h2>
      </div>
      <div className="p-4">
        <Table
        
          columns={columns}
          dataSource={displayedData}
          pagination={false}
          bordered
          className="mb-4"
          rowClassName={(record, index) => (index % 2 === 0 ? 'bg-gray-50' : 'bg-white')}
        />
        <div className="flex justify-center my-3">
          <Button
            onClick={() => setExpanded(!expanded)}
            icon={expanded ? <UpOutlined /> : <DownOutlined />}
            className="flex items-center bg-blue-500 text-white rounded-lg px-6 py-5"
          >
            {expanded ? 'Show Top 5' : 'View All Records'}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default TopProductsTable;
